import React, { useState } from 'react';
import { getCountryCode, titleCaseString } from 'utils/helpers';
import CallConnectPopup from 'components/Layout/CallConnectPopup/CallConnectPopup';
import { useSelector } from 'react-redux';
import Button from 'components/form/Button';
import LeadStatus from '../LeadStatus';
import "./BasicInfo.scss"
import usePermission from 'hooks/usePermission';
import { icons } from 'utils/constants';
import AddCoAuthorPopup from './AddCoAuthorPopup';

const BasicInfo = ({ paperData, triggerChatTab,triggerEmailTab, onLeadChange }) => {
  const {
    conference,
    paperTitle,
    paperId,
    memberId,
    lead,
    paper_keywords,
    authorName,
    co_author_details,
    authorEmail,
    authorPhone,
    whatapp_number,
    authorCountry,
    department,
    submitted_from,
    user_country_code,
    user_mobile_no,
    user_id,
    whatsapp_number_country,
    contact_number,
    contact_number_country,
    whatsapp_country_code,
    contact_country_code,
    university,
    remarks,
    date_of_submission,
    id,
    payment_status
  } = paperData || {};

  const isLatestPaper = paperData?.latest_paper_title
    ? paperData?.latest_paper_title
    : '';
  let newPaperTitle = isLatestPaper
    ? paperData?.latest_paper_title
    : paperTitle;
  const [isCallConnect, setIsCallConnect] = useState({});

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const { viewAccess, createAccess, updateAccess, deleteAccess } = usePermission('Event Management');
  const user_type = ['6'].includes(userDetails.user_type);

  const [showCoAuthorPopup, setShowCoAuthorPopup] = useState(false)


  return (
    <>
      {showCoAuthorPopup && (
        <AddCoAuthorPopup
          show={showCoAuthorPopup}
          onHide={() => setShowCoAuthorPopup(false)}
          paperData={paperData}
        />
      )}

      <div className='basic-info-container'>
        <div className="cps-44 cpt-15 cpe-44 cpb-15">
          <div className="row custom-border-bottom gx-0 cpb-10 normal-screen-header">
            <div className="col-lg-8">
              <h2 className="text-16-400-20 color-new-car">
                Conference & Abstract Info :
              </h2>
            </div>
            <div className="col-lg-4 cps-20">
              <h2 className="text-16-400-20 color-new-car">
                Author’s & Contact Info :
              </h2>
            </div>
          </div>

          <div className="row gx-lg-0 gy-5">
            <div className="col-lg-8 custom-border-end pt-2">
              <h2 className="text-16-400-20 color-new-car cpb-10 mobile-screen-header">
                Conference & Abstract Info :
              </h2>
              {conference && (
                <>
                  <div className="text-14-400-17 color-new-car">
                    Conference Name:
                  </div>
                  <p className="text-14-300-24 color-black-olive cmb-20">
                    {titleCaseString(conference)}
                  </p>
                </>
              )}
              {newPaperTitle && (
                <>
                  <div className="text-14-400-17 color-new-car">Paper Title:</div>
                  <p className="text-14-300-24 color-black-olive cmb-20">
                    {titleCaseString(newPaperTitle)}
                  </p>
                </>
              )}
              {university &&
                <>
                  <div className="text-14-400-17 color-new-car">University :</div>
                  <p className="text-14-300-24 color-black-olive cmb-20">
                    {university}
                  </p>

                </>}
              {date_of_submission &&
                <>
                  <div className="text-14-400-17 color-new-car">Date Of Submission :</div>
                  <p className="text-14-300-24 color-black-olive cmb-20">
                    {date_of_submission}
                  </p>

                </>}



              <div className="row cmb-20 gy-3">
                {paperId && (
                  <div className="col-lg-6">
                    <div className="text-14-400-17 color-new-car">Paper ID:</div>
                    <span className="text-14-300-24 color-black-olive">
                      {paperId}
                    </span>
                  </div>
                )}
                {memberId && (
                  <div className="col-lg-6">
                    <div className="text-14-400-17 color-new-car">Member ID:</div>
                    <span className="text-14-300-24 color-black-olive">
                      {memberId}
                    </span>
                  </div>
                )}
              </div>

              {department && (
                <div className="d-flex flex-column cmb-20">
                  <div className="text-14-400-17 color-new-car">Department:</div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span className="text-14-300-24 color-black-olive">
                      {department}
                    </span>
                  </div>
                </div>
              )}

              {paper_keywords?.length > 0 && (
                <div className="d-flex align-items-center gap-4">
                  <div className="text-14-400-17 color-new-car">Keywords:</div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    {paper_keywords?.map((words, index) => {
                      return (
                        <span
                          key={index}
                          className="bg-f4ff color-new-car cps-8 cpe-8 cpt-2 cpb-2 br-2 text-14-400-17"
                        >
                          {words}
                        </span>
                      );
                    })}
                  </div>
                </div>
              )}


            </div>

            <div className="col-lg-4 custom-padding">
              <h2 className="text-16-400-20 color-new-car cpb-10 mobile-screen-header">
                Author’s & Contact Info :
              </h2>
              <div className="d-flex align-items-center gap-2 cmb-20">
                {authorName && (
                  <>
                    <div className="text-14-400-17 color-new-car">Author:</div>
                    <div className="d-flex align-items-center text-14-300-17 color-black-olive me-2">
                      {authorName}
                    </div>
                  </>
                )}
                {/* {lead && (
                <span className={`${leadColorWithBG(lead)} text-14-400-17`}>
                  {lead}
                </span>
              )} */}

                {['0', '1', '6'].includes(userDetails.user_type) && updateAccess === "1" &&
                  <LeadStatus abstract_id={id} lead={lead} onSuccess={(newLead) => onLeadChange(newLead)}
                  />}
              </div>


              <>
                <div className="text-14-400-17 color-new-car cmb-8">
                  Co Author:
                </div>
                {co_author_details?.length > 0 ? (
                  <div className="d-flex align-items-center gap-2 flex-wrap cmb-20">
                    {co_author_details?.slice()
                      ?.sort((a, b) => {
                        const order = [1, 2, 0];
                        return order.indexOf(a.co_author_status || 0) - order.indexOf(b.co_author_status || 0);
                      })
                      ?.map((coAuthor, index) => {
                        const bgClass =
                          coAuthor.co_author_status === 1
                            ? "bg-a35b color-white"
                            : coAuthor.co_author_status === 2
                              ? "bg-C991 color-white"
                              : "bg-f4ff color-new-car";

                        return (
                          <span
                            key={index}
                            className={`cps-8 cpe-8 cpt-2 cpb-2 br-2 text-14-400-17 ${bgClass}`}
                          >
                            {coAuthor?.name}
                          </span>
                        );
                      })}

                    {(!payment_status || payment_status !== "1") && updateAccess === "1" && (
                      <Button
                        icon={<img src={icons.primaryEditPen} alt="" />}
                        className="h-35 border-none"
                        onClick={() => setShowCoAuthorPopup(true)}
                      />
                    )}

                    {/* {co_author_details?.map((coAuthor, index) => {
                      return (
                        <span
                          key={index}
                          className="bg-f4ff color-new-car cps-8 cpe-8 cpt-2 cpb-2 br-2 text-14-400-17"
                        >
                          {coAuthor?.name}
                        </span>
                      );
                    })} */}
                  </div>
                )
                  :
                  (!payment_status || payment_status !== "1") && createAccess === "1" && (
                    <div className="d-flex justify-content-start align-items-center cmb-5">
                      <Button
                        text="+ Add Co-Authors"
                        className="h-35 primary-light-outline text-12-500-15"
                        onClick={() => setShowCoAuthorPopup(true)}
                      />
                    </div>
                  )}
              </>

              {authorEmail && (
                <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-20">
                  <i className="bi bi-envelope" /> {authorEmail}
                  {['6'].includes(userDetails.user_type) && createAccess === '1' && (
                  <Button
                    text="Email"
                    btnStyle="primary-outline-car"
                    className="cps-10 cpe-10 h-30 text-14-400-15"
                    onClick={() => triggerEmailTab()}
                  /> )}
                </div>
              )}
              {whatapp_number && (
                <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-20">
                  <i className="bi bi-whatsapp" />{' '}
                  {/* {`${getCountryCode(
                  whatsapp_number_country,
                  'dial_code',
                  'name'
                )} ${whatapp_number}`} */}
                  {whatsapp_country_code} {whatapp_number}
                  {user_type && createAccess === '1' && (
                    <Button
                      text="Chat"
                      btnStyle="primary-outline-car"
                      className="cps-15 cpe-15 gap-2 h-30 text-14-400-15"
                      onClick={() => triggerChatTab()}
                    />
                  )}
                </div>
              )}
              {contact_number && (
                <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-20">
                  <i className="bi bi-telephone" />{' '}
                  {/* {`${getCountryCode(
                  contact_number_country,
                  'dial_code',
                  'name'
                )} ${contact_number}`} */}
                  {contact_country_code} {contact_number}
                  {userDetails?.call_integration === '1' && (
                    <span
                      className={`call-status-default text-14-400-17 pointer`}
                      onClick={() => {
                        setIsCallConnect({
                          user_country_code,
                          user_mobile_no,
                          user_id,
                        });
                      }}
                    >
                      Connect Call
                    </span>
                  )}
                </div>
              )}
              {authorCountry && (
                <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-10">
                  <i className="bi bi-globe-americas" /> {authorCountry}
                </div>
              )}

              {submitted_from && (
                <>
                  <div className="text-14-400-17 color-new-car"> Source:</div>
                  <div className="d-flex align-items-center text-14-300-17 color-black-olive me-2">
                    {submitted_from}
                  </div>
                </>
              )}

              {remarks && <>
                <div className="text-14-400-17 color-new-car cmt-10"> Remarks :</div>
                <div className="d-flex align-items-center text-14-300-17 color-black-olive me-2">
                  {remarks}
                </div>
              </>}
            </div>
          </div>
        </div>

        {isCallConnect && Object.keys(isCallConnect).length > 0 && (
          <CallConnectPopup
            onHide={() => setIsCallConnect({})}
            data={isCallConnect}
          />
        )}
      </div>
    </>
  );
};

export default BasicInfo;
